<form [formGroup]="iconForm" class="icon-form">
    <tui-icon [icon]="selectedIcon" id="icon-search-icon"></tui-icon>
    <tui-input formControlName="iconControl" (ngModelChange)="filterIcons()" tuiTextfield>
        {{ placeholderText }}
        <input tuiTextfieldLegacy />
    </tui-input>
    <section>
        @for (icon of filteredIcons; track icon) {
            <button tuiButton appearance="secondary" (click)="selectIcon(icon)">
                <tui-icon [icon]="icon"></tui-icon>
            </button>
        }
    </section>
</form>
